import axiosInstance from '../axios';

import { API_GET_QUICKSIGHT_DASHBOARD_URL } from '../constants';

// get embedded dashboard url of aws quicksight
// eslint-disable-next-line import/prefer-default-export
export async function getEmbeddedQuicksightDashboardURL(params) {
  const result = await axiosInstance
    .get(`${API_GET_QUICKSIGHT_DASHBOARD_URL}`, { params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
}
